import {
    InfoIcon,
    SettingsIcon,
    DrawPolygonIcon,
    BuildingIcon,
    DrawLineIcon,
    PinIcon,
    LayersIcon,
    ImportIcon,
    RulerIcon,
    ListIcon,
    PrintIcon,
    GlobeIcon,
    ViewIcon,
    EditIcon
} from '../../../components/Icon';

// Статьи
import { overviewArticle } from './articles/overview';
import { publicPartArticle } from './articles/public-part';
import { adminPartArticle } from './articles/admin-part';
import { workspacesArticle } from './articles/workspaces';
import { drawOverviewArticle } from './articles/draw-overview';
import { drawPlotsArticle } from './articles/draw-plots';
import { drawBuildingsArticle } from './articles/draw-buildings';
import { drawLinesArticle } from './articles/draw-lines';
import { drawMarkersArticle } from './articles/draw-markers';
import { basemapsArticle } from './articles/basemaps';
import { importExportArticle } from './articles/import-export';
import { measurementsArticle } from './articles/measurements';
import { legendArticle } from './articles/legend';
import { objectManagerArticle } from './articles/object-manager';
import { nspdArticle } from './articles/nspd';
import { exportPrintArticle } from './articles/export-print';
import { spdPlusArticle } from './articles/spd-plus';

const WrenchIcon = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
    </svg>
);

export const ichisSpdRegistry = {
    title: 'Руководство пользователя',
    version: '1.0.0',
    categories: [
        {
            id: 'getting-started',
            title: 'Основы',
            items: [
                { ...overviewArticle, icon: InfoIcon },
                { ...publicPartArticle, icon: ViewIcon },
                { ...adminPartArticle, icon: EditIcon },
                { ...workspacesArticle, icon: ListIcon }
            ]
        },
        {
            id: 'drawing',
            title: 'Режим рисования',
            items: [
                { ...drawOverviewArticle, icon: InfoIcon },
                { ...drawPlotsArticle, icon: DrawPolygonIcon },
                { ...drawBuildingsArticle, icon: BuildingIcon },
                { ...drawLinesArticle, icon: DrawLineIcon },
                { ...drawMarkersArticle, icon: PinIcon },
                { ...basemapsArticle, icon: LayersIcon },
                { ...importExportArticle, icon: ImportIcon }
            ]
        },
        {
            id: 'data',
            title: 'Режим Данные',
            items: [
                { ...measurementsArticle, icon: RulerIcon },
                { ...legendArticle, icon: ListIcon },
                { ...objectManagerArticle, icon: SettingsIcon }
            ]
        },
        {
            id: 'modules-extended',
            title: 'Модули расширения',
            items: [
                { ...nspdArticle, icon: GlobeIcon },
                { ...exportPrintArticle, icon: PrintIcon },
                { ...spdPlusArticle, icon: WrenchIcon }
            ]
        }
    ]
};
